var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.4997C9.8865 12.4997 8.1665 10.7797 8.1665 8.66634C8.1665 6.55301 9.8865 4.83301 11.9998 4.83301C14.1132 4.83301 15.8332 6.55301 15.8332 8.66634C15.8332 10.7797 14.1132 12.4997 11.9998 12.4997ZM11.9998 5.83301C10.4398 5.83301 9.1665 7.10634 9.1665 8.66634C9.1665 10.2263 10.4398 11.4997 11.9998 11.4997C13.5598 11.4997 14.8332 10.2263 14.8332 8.66634C14.8332 7.10634 13.5598 5.83301 11.9998 5.83301Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7268 19.1667C17.4534 19.1667 17.2268 18.94 17.2268 18.6667C17.2268 16.3667 14.8801 14.5 12.0001 14.5C9.1201 14.5 6.77344 16.3667 6.77344 18.6667C6.77344 18.94 6.54677 19.1667 6.27344 19.1667C6.0001 19.1667 5.77344 18.94 5.77344 18.6667C5.77344 15.82 8.56677 13.5 12.0001 13.5C15.4334 13.5 18.2268 15.82 18.2268 18.6667C18.2268 18.94 18.0001 19.1667 17.7268 19.1667Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8e5333e06b203d0d9e6a66b5ad60aa4a.svg";
export { ForwardRef as ReactComponent };